<template>
    <div class="module-in-development">
        <h2>Модуль в разработке</h2>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.module-in-development {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
}
</style>